import styles from "./SectionHeader.module.scss";

type SectionHeaderProps = {
  children?: React.ReactNode;
  heading: string;
  ariaLabel?: string;
  testId?: string;
};

export function SectionHeader({
  children,
  heading,
  ariaLabel,
  testId,
}: SectionHeaderProps) {
  return (
    <div className={styles.header} data-testid={testId}>
      <h2 className={styles.headingText} aria-label={ariaLabel}>
        {heading}
      </h2>
      {children}
    </div>
  );
}
